import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
// eslint-disable-next-line no-restricted-imports -- the design-system selects take a FormControl until KAB-2438
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {TextInputComponent} from '../../text-input/text-input.component';
import {IconButtonComponent} from '../../icon-button/icon-button.component';

@Component({
  selector: 'app-select-search',
  templateUrl: './select-search.component.html',
  styleUrl: '../multi-select.component.scss',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- app-multi-select resets and disables this control from outside (onClose, delete mode): under OnPush the clear button and the disabled state would go stale
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TextInputComponent, IconButtonComponent, TranslatePipe]
})
export class SelectSearchComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals -- app-multi-select reads it as a property (contentChild): a signal input comes with multi-select's migration
  @Input() searchControl: FormControl;
}
